<template>
    <div>
      <div style="text-align:center;width:100%;padding:10px;font-size:28px;font-weight:300;">
        {{greetText}}, {{identity.split(' ')[0]}}
      </div>
      <v-layout wrap>
        <v-flex
          md6
          style="padding:20px"
        >
          <v-card>
            <v-toolbar
              dense
              flat
              dark
              color="#212121"
            >
              <v-icon
                style="padding-right: 10px;"
                color="#81D4FA"
              >
                mdi-shimmer
              </v-icon>
              <div
                style="font-weight: 900;"
              >
                New Features in {{ app_name }}
              </div>
              <v-spacer />
              <div>v0.9.07</div>
            </v-toolbar>
            <v-card-text>
              <div style="display:flex;">
                <v-icon
                  left
                  class="elevation-1"
                  dark
                  style="background: #558B2F;padding:10px;border-radius: 50%;align-self: flex-start;"
                >
                  mdi-newspaper
                </v-icon>
                <div>
                  <div
                    style="font-size: 18px;font-weight:700;"
                  >
                    News
                  </div>
                  <div>
                    Introducing Organization &amp; Case News, allowing for a news feed of articles, with attached videos, cover images, and files.
                  </div>
                </div>
              </div>
              <br />
              <div style="display:flex;">
                <v-icon
                  left
                  class="elevation-1"
                  dark
                  style="background: #00838F;padding:10px;border-radius: 50%;align-self: flex-start;"
                >
                  mdi-webhook
                </v-icon>
                <div>
                  <div
                    style="font-size: 18px;font-weight:700;"
                  >
                    Webhooks &amp; API Tokens
                  </div>
                  <div>
                    {{ app_name }} now supports webhooks to call third-party services when updates occur, and introduces support for API tokens.
                  </div>
                </div>
              </div>
              <br />
              <div style="font-size: 16px;">
                <v-icon
                  left
                >
                  mdi-chevron-triple-down
                </v-icon>
                <span>Minor Changes</span>
              </div>
              <div style="font-size:12px;margin-left: 40px;">
                <span v-if="app_name == 'CaseLocker'">View the full changelog at our <a href="https://litigationlocker.zendesk.com/hc/en-us/articles/30234500555533-CaseLocker-v0-9-04">Support Center</a>.</span>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex
          md6
          style="padding:20px"
        >
          <v-card>
            <v-card-title
              style="border-bottom:1px lightblue solid;"
            >
              Recently Viewed
            </v-card-title>
            <v-card-text
              style="padding:0;"
            >
              <v-list>
                <div
                  v-for="item in lastViewedObjects"
                  :key="`${item.type}-${item.id}`"
                >
                  <v-list-tile
                    avatar
                    @click="$router.push({ name: item.type && item.type == 'form' ? 'UserForm' : 'Contact', params: { id: item.id } })"
                  >
                    <v-list-tile-action>
                      <v-icon>
                        {{ item.type == "form" ? 'assignment' : 'person'}}
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content
                      v-if="item.type == 'form'"
                    >
                      <v-list-tile-title>{{item.party_name}} | {{item.form_number}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.name}}
                        <span
                          v-if="item.tags.length > 0"
                          style="padding-left:20px;"
                        >
                          <span
                            v-for="tag in item.tags"
                            class="inline-tag"
                          >
                            {{tag}}
                          </span>
                        </span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-content
                      v-if="item.type == 'contact'"
                    >
                      <v-list-tile-title>{{item.full_name}} | {{item.cuid}}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span
                          v-if="item.tags.length > 0"
                        >
                          <span
                            v-for="tag in item.tags"
                            class="inline-tag"
                          >
                            {{tag}}
                          </span>
                        </span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
</template>

<script>
export default {
  name: 'AppHome',
  created () {
    this.documentTitle('Home')
  },
  data () {
    return {
      identity: localStorage.getItem('user-full-name'),
      lastViewedObjects: JSON.parse(localStorage.getItem('user-last-viewed:' + this.$store.state.auth.id))
    }
  },
  computed: {
    greetText () {
      var hr = (new Date()).getHours()
      switch (true) {
        case (hr < 12):
          return 'Good Morning'
          break
        case (hr < 17):
          return 'Good Afternoon'
          break
        case (hr < 20):
          return 'Good Evening'
          break
        default:
          return 'Hello'
          break
      }
    }
  }
}
</script>

<style>

.inline-tag {
  display:inline-block;
  font-weight: bold;
  background-color:lightgrey;
  color:white;
  border-radius:3px;
  padding:3px 4px 2px 4px;
  text-align:center;
  margin-right:5px;
  line-height:12px;
}

</style>
